import React, { createContext, useContext } from "react"

import Store from "./store"

/* 
CONTEXT / PROVIDER INIT
*/

const CounterfeitReportContext = createContext<Store | null>(null)

export const StoreProvider: React.FC = (props) => {
    const { children } = props

    return (
        <CounterfeitReportContext.Provider value={new Store()}>
            {children}
        </CounterfeitReportContext.Provider>
    )
}

/* 
HOOK DEFINITION
*/

export const useCounterfeitReportStore = () => useContext(CounterfeitReportContext)
